import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useClient } from "../../context/ClientContext";

// Entran el dueño de la tienda (rol 1) y el vendedor (rol 3).
export const VendedorRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const { clientPath } = useClient();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to={clientPath('/login')} replace />;
  if (user?.id_rol !== 1 && user?.id_rol !== 3) return <Navigate to={clientPath('/')} replace />;

  return children;
};
